import { Injectable, ErrorHandler } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MenuController } from '@ionic/angular';

import { ToastService } from 'src/app/core/services/utils/toast.service';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorService implements ErrorHandler {
  constructor(
    private toastService: ToastService,
    private authService: AuthService,
    private menuController: MenuController
  ) {}

  handleError(error: any): void {
    if (Error instanceof HttpErrorResponse) {
      console.log(error.status);
    } else {
      console.error(error);
    }

    if (error === 'No current user') {
      this.signOut();
    } else {
      this.toastService.showToast('Oops! Please refresh your browser or sign-out.', 'danger');
    }
  }

  private async signOut(): Promise<void> {
    await this.authService.signOut();
    this.menuController.close();
  }
}
